import React, { useRef, useEffect } from 'react';
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import Heroimage from "../components/Heroimage";
import Forms from '../components/Forms';
import { FaPhone, FaEnvelope } from 'react-icons/fa';
import './register.css'; // Import the CSS file
import Registerimage from '../components/Registerimage';

const Register = () => {
  const formRef = useRef(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      formRef.current.scrollIntoView({ behavior: 'smooth' });
    }, 5000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="register-page">
      <Navbar />
      
      <div className="hero-section">
        {/* Hero image or text */}
      </div>
      <div className="content-section">
        <div ref={formRef} className="form-container">
          <Registerimage/>
        </div>
        {/* <div className="contact-details">
          <p><FaPhone /> Phone: <a href="tel:1234567890">+91-9000000000</a></p>
          <p><FaEnvelope /> Email: <a href="mailto:info@example.com">knoratec@gmail.com</a></p>
        </div> */}
      </div>
      {/* <Footer /> */}
    </div>
  );
};


export default Register;
